<template>
	<!--header start-->
	<div class="container-fluid p-0 sticky-header" id="rc1-header">
		<div
			:class="[
				'row',
				'g-0',
				isLanding ? 'no-header-container' : 'header-container header-padding',
				'rc1-header',
			]">
			<div class="col-12 d-flex justify-content-between align-items-center">
				<div
					class="logo-container float-start"
					@click="LogoClick"
					style="cursor: pointer">
					<figure class="m-0">
						<div class="header-logo-cont">
							<img
								class="carinsurance-logo"
								:src="getLogoImage()"
								alt="Carinsurance.com" />
						</div>
						<!-- <figcaption class="theme-font logo-text">
							<span>POWERED BY</span
							><span class="fw-bold"> INSURE-AGENT.COM</span>
						</figcaption> -->
					</figure>
				</div>
				<div class="contact-container float-end">
					<div class="px-3 py-2">
						<span class="contact-link me-2 theme-font d-none d-md-inline"
							>Call Agent</span
						>
						<a
							:href="`tel:${$theme.phonePrimary}`"
							class="contact-link me-2 theme-font d-md-none text-decoration-none"
							>Call Agent</a
						>
						<span class="call-icon-span"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								width="15"
								height="15"
								fill="currentColor"
								class="align-middle bi bi-telephone-fill"
								viewBox="0 0 16 16">
								<path
									fill-rule="evenodd"
									d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" /></svg
						></span>
						<span class="theme-font fw-bold d-none d-md-block float-end ms-3"
							><a class="phone-num" :href="`tel:${$theme.phonePrimary}`">{{
								$theme.phonePrimary
							}}</a></span
						>
					</div>
				</div>
			</div>
		</div>
		<!-- Progress bar start-->
		<div
			v-if="
				this.$route.name === 'thankyouPage' || this.$route.name === 'not-found'
			">
			<div
				class="col-12 res_agentIcon text-center sticky-agent-icon"
				v-show="this.$route.name === 'thankyouPage'">
				<img
					class=""
					:src="getAgentImage()"
					style="height: 60px; width: 60px"
					alt="Agent" />
			</div>
		</div>
		<div v-else :class="['row', 'g-0', isLanding ? 'd-none' : '']">
			<div class="col-12">
				<div
					class="round-progress mx-auto position-relative"
					:value="progressCal">
					<span class="progress-left start-0">
						<span
							class="progress-bar w-100 h-100 border-circle top-0 position-absolute"></span>
					</span>
					<span class="progress-right end-0">
						<span
							class="progress-bar w-100 h-100 border-circle top-0 position-absolute"></span>
					</span>

					<div
						class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center position-absolute top-0 start-0">
						<div class="theme-font fw-bold">{{ progressCal }}<sup>%</sup></div>
					</div>
				</div>
			</div>
		</div>

		<!-- Progress bar end -->
	</div>
	<!-- Header end -->
</template>
<script>
/* eslint-disable  */

export default {
	data() {
		return {
			isLanding: false,
		};
	},
	computed: {
		progressCal() {
			console.log('routing details', this.$route.name);
			if (
				this.$route.name === 'vehicle-info' ||
				this.$route.name === 'add-vehicle'
			) {
				return 38;
			}
			if (
				this.$route.name === 'driver-info' ||
				this.$route.name === 'add-driver' ||
				this.$route.name === 'driver-summary'
			) {
				return 62;
			}
			if (
				this.$route.name === 'details-info' ||
				this.$route.name === 'incident-summary' ||
				this.$route.name === 'incident-details'
			) {
				return 79;
			}
			return 17;
		},
	},
	methods: {
		/**
		 * return client specific avatar
		 */
		getLogoImage() {
			return require(`../../../../../config/${this.$theme.clientFolder}/assets/logo_img.svg`);
		},
		getAgentImage() {
			return require(`../../../../../config/${this.$theme.clientFolder}/assets/agent.png`);
		},
		LogoClick() {
			this.$router.push({ path: this.$route.path });
			this.$emit('onLogoClick');
		},
		checkIsLanding() {
			if (this.$route.name === 'Landing') {
				this.isLanding = true;
			}
		},
	},
	created() {
		console.log(' I am in header and theme is', this.$theme);
		this.checkIsLanding();
	},
};
</script>
<style scoped>
.header-padding{
	padding-top: 0.75rem !important;
	padding-bottom: 0.75rem !important;
}
@media (min-width: 992px) {
.header-padding{
	padding-top: 1.25rem !important;
	padding-bottom: 1.25rem !important;
}
}
</style>